import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';

const resource = `${Config.basePath}/quick-message`;

export default {
  show() {
    return Client.get(`${resource}`);
  },
  create(payload) {
    return Client.post(`${resource}`, payload);
  },
  update(payload, id) {
    return Client.put(`${resource}/${id}`, payload);
  },
  bulkUpdate(payload) {
    return Client.put(`${resource}/item`, { items: payload });
  },
  delete(id) {
    return Client.delete(`${resource}/${id}`);
  },
  search(payload) {
    return Client.post(`${resource}/search`, payload);
  },
};
